import React, { useState } from 'react';
import Button from '../Button';
import { MdOutlineDelete } from 'react-icons/md';
import AddIcon from '../Icons/AddIcon';

interface ImageFormPromoProps {
  image: string;
  handleRemove: () => void;
}
const ImageFormPromo = ({ image, handleRemove }: ImageFormPromoProps) => {
  const openImageInNewTab = () => {
    if (image) {
      const openedWindow = window.open(image, '_blank');
      if (openedWindow) {
        openedWindow.focus();
      }
    }
  };

  return (
    <div className="relative h-auto w-full">
      <div onClick={openImageInNewTab} className="cursor-pointer">
        <img src={image} alt="image" className="object-cover w-full max-h-[550px]" />
      </div>
      <div>
        <Button color="gray" className="absolute bottom-5 right-5" onClick={handleRemove}>
          <span className="flex flex-row gap-1 font-bold uppercase text-sm">
            <MdOutlineDelete size={'20px'} /> Hapus
          </span>
        </Button>
      </div>
    </div>
  );
};

interface DropzoneProps {
  onChange?: (file: File) => void;
  onRemove?: () => void;
  containerClassName?: string;
  initialValue?: string;
}

export default function Dropzone({
  onChange = () => {},
  onRemove = () => {},
  containerClassName,
  initialValue,
}: DropzoneProps) {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [error, setError] = useState<{
    dimensionError: string;
    sizeError: string;
  }>({
    dimensionError: '',
    sizeError: '',
  });

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      // Check file size (2 MB = 2 * 1024 * 1024 bytes)
      if (file.size > 2 * 1024 * 1024) {
        setError({
          dimensionError: '',
          sizeError: 'Batas maksimal upload 2MB',
        });
        return;
      } else {
        setError({
          dimensionError: '',
          sizeError: '',
        });
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new window.Image();
        img.src = e.target.result as string;
        img.onload = () => {
          const aspectRatio = 16 / 9;

          const width = img.width;
          const height = img.height;
          const currentAspectRatio = width / height;

          // Calculate new dimensions
          let newWidth, newHeight;

          if (currentAspectRatio > aspectRatio) {
            // If the image is wider than the desired aspect ratio
            newWidth = height * aspectRatio;
            newHeight = height;
          } else {
            // If the image is taller than the desired aspect ratio
            newWidth = width;
            newHeight = width / aspectRatio;
          }

          // Create a canvas to draw the resized image
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = newWidth;
          canvas.height = newHeight;

          // Calculate the position to center the image
          const offsetX = (newWidth - width) / 2;
          const offsetY = (newHeight - height) / 2;

          // Draw the image on the canvas
          ctx.drawImage(img, offsetX, offsetY, width, height);

          setSelectedFile(file);

          if (onChange) {
            onChange(file);
          }

          // Convert the canvas to a blob
          // canvas.toBlob(
          //   (blob) => {
          //     const transformedFile = new File([blob], file.name, { type: 'image/jpeg' });
          //     setSelectedFile(transformedFile);

          //     if (onChange) {
          //       onChange(transformedFile); // Pass the transformed file to the onChange function
          //     }

          //     setError({
          //       dimensionError: '',
          //       sizeError: '',
          //     });
          //   },
          //   'image/jpeg',
          //   0.9
          // );
        };
      };

      reader.readAsDataURL(file);
    }
  };

  const handleRemove = () => {
    setSelectedFile(null);

    if (onRemove) {
      onRemove();
    }
  };

  return (
    <div className={containerClassName}>
      <div className="block items-center justify-center md:w-[328px] mb-3">
        {!selectedFile && !initialValue && (
          <label
            htmlFor="dropzone-file"
            className="relative flex flex-col items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer"
          >
            <div className="relative flex flex-col items-center justify-center pt-5 pb-6">
              <p className="text-xs mb-2 text-gray-500 text-center dark:text-gray-400">
                Format file: Jpeg, JPG, PDF, PNG, TIFF <br />
                Ukuran maksimal 2MB
              </p>

              <Button
                className="!h-12 text-reliableBlack border-[1px] border-reliableBlack"
                variant="bg-white"
              >
                <p className="flex items-center gap-1 text-sm text-black font-semibold uppercase">
                  <AddIcon fill="black" size={20} /> Unggah
                </p>
              </Button>
              {/* <p className="text-xs text-gray-500 text-center dark:text-gray-400">
                Ukuran Ratio : 16:9 <br />
                Rekomendasi Resolusi Gambar : 1024 x 576
              </p> */}
            </div>
            <input
              id="dropzone-file"
              type="file"
              className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
              accept=".jpg, .jpeg, .png, .pdf .tiff"
              onChange={handleFileChange}
            />
          </label>
        )}

        {selectedFile && (
          <ImageFormPromo image={URL.createObjectURL(selectedFile)} handleRemove={handleRemove} />
        )}

        {initialValue && selectedFile === null && (
          <ImageFormPromo image={initialValue} handleRemove={handleRemove} />
        )}

        {error.dimensionError && (
          <div className="flex items-center gap-[5.67px]">
            <span className="text-supportiveRed text-[14px] leading-[20px] font-[400]">
              {error.dimensionError}
            </span>
          </div>
        )}

        {error.sizeError && (
          <div className="flex items-center gap-[5.67px]">
            <span className="text-supportiveRed text-[14px] leading-[20px] font-[400]">
              {error.sizeError}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
